import React, { useState } from "react";
import { RobotOutlined } from "us.icons";
import "./FloatingAIChatButton.scss";
import { $Tooltip } from "us.common/components";
import { useTranslation } from "react-i18next";

type FloatingAIChatButtonProps = {
  onClick: () => void;
};

const FloatingAIChatButton: React.FC<FloatingAIChatButtonProps> = ({
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();

  return (
    <$Tooltip
      title={t("US.COMMON:UNIQ.UNIQ_ASSISTANT")}
      placement="bottom"
      open={isHovered}
      overlayClassName="floating-ai-chat-tooltip"
    >
      <div
        className={`floating-ai-chat-button ${isHovered ? "hovered" : ""}`}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="button-content">
          <div className="icon-container">
            <RobotOutlined className="ai-icon" />
          </div>
        </div>
      </div>
    </$Tooltip>
  );
};

export default FloatingAIChatButton;
